import { label } from "framer-motion/client";
import { getUserUniqueKey } from "./helper_functions"


export const STORAGE_KEYS = {
    FX_USER_ACCESS_TOKEN: "fx_user_access_token",
    FX_USER_ID: "fx_user_id",
    FX_USER_UNIQUE_KEY: 'fx_user_unique_key',
    TOUR_STORAGE_KEY: 'fx_tour_flags',
    FX_USER_REMEMBER_ME: () => `fx_user_remember_me_${getUserUniqueKey()}`,
    USER_ACTIVITY_TABLE_KEY: () => `activity_${getUserUniqueKey()}`,
    USER_WALLET_TABLE_KEY: () => `wallet_${getUserUniqueKey()}`,
    CRYPTO_PAYMENTS_TABLE_KEY: () => `crypto_payments_${getUserUniqueKey()}`,
    REFERRAL_USERS_TABLE_KEY: () => `referral_users_${getUserUniqueKey()}`,
    ACTIVE_REFERRAL_USERS_TABLE_KEY: () => `active_referral_users_${getUserUniqueKey()}`,
    EARNING_TABLE_KEY: () => `earning_${getUserUniqueKey()}`,
    CASHOUT_LOGS_TABLE_KEY: () => `cashout_${getUserUniqueKey()}`,
    ACCOUNT_VIEW_KEY: () => `acc_view_${getUserUniqueKey()}`,
    ACCOUNT_TABLE_KEY: () => `acc_${getUserUniqueKey()}`,
    ACCOUNT_PENDING_ORDERS_TABLE_KEY: () => `acc_pending_orders_${getUserUniqueKey()}`,
    ACCOUNT_POSITION_TABLE_KEY: () => `acc_position_${getUserUniqueKey()}`,
    ACCOUNT_HISTORY_TABLE_KEY: () => `acc_history${getUserUniqueKey()}`,
    ACCOUNT_TRADE_HISTORY_TABLE_KEY: (type) => `acc_trade_history_${type}_${getUserUniqueKey()}`,
    IND_ORDERS_HISTORY_TABLE_KEY: () => `ind_orders_${getUserUniqueKey()}`,
    GRP_ORDERS_HISTORY_TABLE_KEY: () => `grp_orders_${getUserUniqueKey()}`,
    GRP_ORDERS_USERS_TABLE_KEY: () => `grp_orders_users_${getUserUniqueKey()}`,
    GRP_POSITION_TABLE_KEY: () => `grp_position_${getUserUniqueKey()}`,
    GRP_PENDING_ORDERS_TABLE_KEY: () => `grp_pending_orders_${getUserUniqueKey()}`,
    GRP_PENDING_ORDERS_USERS_TABLE_KEY: () => `grp_pending_orders_users_${getUserUniqueKey()}`,
    GROUP_CHILD_VIEW_KEY: () => `grp_child_view_${getUserUniqueKey()}`,
    GROUP_CHILD_TABLE_KEY: () => `grp_child_${getUserUniqueKey()}`,
    DASHBAORD_ACCOUNT_INFO_VIEW: () => `d_acc_view_${getUserUniqueKey()}`,
    DASHBOARD_GRUP_INFO_VIEW: () => `d_grp_view_${getUserUniqueKey()}`,
    DASHBOARD_BRIDGE_INFO_VIEW: () => `d_bridge_view_${getUserUniqueKey()}`,
    BRIDGE_SIGNAL_TABLE_KEY: () => `bridge_signals_${getUserUniqueKey()}`,
    BRIDGE_POSITION_TABLE_KEY: () => `bridge_positions_${getUserUniqueKey()}`,
    PROGRESS_SHOWN: () => `progrees_shown_${getUserUniqueKey()}`,
    BRIDGE_VIEW: () => `bridge_${getUserUniqueKey()}`,
    GROUP_COUNT_KEY: () => `group_count_${getUserUniqueKey()}`,
    IS_DIRECT_KEY: () => `is_direct_${getUserUniqueKey()}`,
    STRATEGY_RECORDS_TABLE_KEY: () => `strategy_records_${getUserUniqueKey()}`,
    STRATEGY_USERS_TABLE_KEY: () => `strategy_users_${getUserUniqueKey()}`,
    STRATEGY_USER_SUBSCRIPTION_TABLE_KEY: () => `strategy_user_subscription_${getUserUniqueKey()}`,
    USER_MANAGEMENT_TABLE_KEY: () => `user_management_${getUserUniqueKey()}`,
    USER_SUBSCRIBED_STRATEGY_TABLE_KEY: () => `user_subscribed_strategy_${getUserUniqueKey()}`,
    USER_WALLET_TABLE_KEY: () => `user_wallet_${getUserUniqueKey()}`,
    USER_REFERRAL_TABLE_KEY: () => `user_referral_${getUserUniqueKey()}`,
    USER_ORDERS_TABLE_KEY: () => `user_orders_${getUserUniqueKey()}`,
    USER_ACTIVITY_LOGS_TABLE_KEY: () => `user_activity_logs_${getUserUniqueKey()}`,
    TRANSACTION_TABLE_KEY: () => `transaction_${getUserUniqueKey()}`,
    ORDER_DETAILS_TABLE_KEY: () => `order_details_${getUserUniqueKey()}`,
    USER_ACCOUNT_TABLE_KEY: () => `user_account_${getUserUniqueKey()}`,
    USER_LABEL_MANAGEMENT_KEY: () => `user_labels_${getUserUniqueKey()}`,
    PRIMARY_COLOR: 'AFX_USER_PRIMARY_COLOR',
    PROFILE: 'AFX_USER_PROFILE',
    IS_THEME_PREVIEW: "is_theme_preview",
    THEME_PREVIEW_COLORS: 'theme_preview_colors',
    THEME_COLORS: 'AFX_THEME_COLORS'
}

// DEFAULT SETTINGS FOR FORMAT
export const DEFAULT_SETTINGS = {
    DATE_FORMAT: 'dd-MM-yyyy',
    PAYLOAD_DATE_FORMAT: 'yyyy-MM-dd',
    DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm:ss'

};

export const BRIDGE_TYPE = {
    CUSTOM: 'custom',
    TRADING_VIEW: 'trading-view'
}
export const UI_TYPE = {
    CARD: 'card',
    TABLE: 'table',
    CHART: 'chart'
}

export const TRANSACTION_TYPE = {
    CREDIT: 'credit',
    DEBIT: 'debit'
}
export const CASHOUT_TYPES = {
    CREDIT: "credit",
    WITHDRAW: "withdraw",
};

export const CASHOUT_STATUSES = {
    PENDING: "pending",
    INITIATED: "initiate",
    COMPLETED: "completed",
    REJECTED: "rejected",
};
// Crypto payment (NOWPayments) statuses, same as backend nowpayments_transactions.status
export const CRYPTO_PAYMENT_STATUS = {
    PENDING: 'pending',
    CONFIRMING: 'confirming',
    COMPLETED: 'completed',
    REVIEW: 'review',
    CREDIT_FAILED: 'credit_failed',
    EXPIRED: 'expired',
    FAILED: 'failed',
    REJECTED: 'rejected'
};
export const CRYPTO_NETWORK_LABELS = {
    usdttrc20: 'USDT (Tron - TRC20)',
    usdtbsc: 'USDT (BNB Smart Chain - BEP20)'
};
export const CRYPTO_PAYMENT_OPEN_STATUSES = [CRYPTO_PAYMENT_STATUS.PENDING, CRYPTO_PAYMENT_STATUS.CONFIRMING];
export const CRYPTO_PAYMENT_STATUS_UI = {
    pending: { label: 'Awaiting Payment', badge: 'warning' },
    confirming: { label: 'Confirming', badge: 'info' },
    completed: { label: 'Completed', badge: 'success' },
    review: { label: 'Under Review', badge: 'warning' },
    credit_failed: { label: 'Under Review', badge: 'warning' },
    expired: { label: 'Expired', badge: 'danger' },
    failed: { label: 'Failed', badge: 'danger' },
    rejected: { label: 'Rejected', badge: 'danger' }
};
export const OLD_ORDER_TYPE = {
    LIMIT: 'LIMIT',
    MARKET: 'MARKET',
    SL: 'SL'
}
export const API_RESPONSE_TYPE = {
    OTP: 'otp',
    OTP_EXPIRED: 'otp-expired',
    OTP_INVALID: 'otp-invalid',
    EMAIL_USED: 'email-used',
}

export const DROPDOWN_OPTIONS = {
    REFERRAL_CASHOUT_OPTION: [
        { value: 'credit', label: 'Credit' },
        { value: 'withdraw', label: 'Withdraw' }
    ],

    WALLET_TRANSACTION_OPTION: [
        { value: 'credit', label: 'Credit' },
        { value: 'debit', label: 'Debit' }
    ],
    CRYPTO_PAYMENT_STATUS_OPTION: [
        { value: 'pending', label: 'Awaiting Payment' },
        { value: 'confirming', label: 'Confirming' },
        { value: 'completed', label: 'Completed' },
        { value: 'review', label: 'Under Review' },
        { value: 'expired', label: 'Expired' },
        { value: 'failed', label: 'Failed' },
        { value: 'rejected', label: 'Rejected' }
    ],
    AGE_RANGE_OPTION: [
        { value: "Below 18", label: "Below 18 years" },
        { value: "18-30", label: "18 - 30 years" },
        { value: "30-50", label: "30 - 50 years" },
        { value: "Above 50", label: "Above 50 years" }
    ],
    ACCOUNT_DURATION_OPTION: [
        { value: "monthly", label: "1 Month | $8" },
        { value: "half_yearly", label: "6 Months | $45" },
        { value: "yearly", label: "12 Months | $84" }
    ],
    PLACE_ORDER_SCRIPT_TYPE: [
        { value: "EQ", label: "Equity" },
        { value: "CE", label: "CE" },
        { value: "PE", label: "PE" },
        { value: "FUT", label: "Future" },
    ],
    PLACE_ORDER_ORDER_OPTION: [
        { value: "MARKET", label: "Market" },
        { value: "LIMIT", label: "Limit" },
        { value: "SL", label: "SL" },
    ],
    PLACE_ORDER_PRODUCT_OPTION: [
        { value: 'INTRADAY', label: 'INTRADAY' },
        { value: 'CARRYFORWARD', label: 'CARRYFORWARD' },
        { value: 'DELIVERY', label: 'DELIVERY' },
    ],
    ORDER_TYPE_OPTION: [
        { value: 0, label: 'BUY' },
        { value: 1, label: 'SELL' },
        { value: 2, label: 'BUY LIMIT' },
        { value: 3, label: 'SELL LIMIT' },
        { value: 4, label: 'BUY STOP' },
        { value: 5, label: 'SELL STOP' },
        { value: 6, label: 'BUY STOP LIMIT' },
        { value: 7, label: 'SELL STOP LIMIT' },

    ],
    DEAL_ENTRY_OPTION: [
        { value: 0, label: 'IN' },
        { value: 1, label: 'OUT' },
    ],
    ORDER_STATE_TYPE_OPTION: [
        { value: 0, label: 'STARTED' },
        { value: 1, label: 'PLACED' },
        { value: 2, label: 'CANCELED' },
        { value: 3, label: 'PARTIAL' },
        { value: 4, label: 'FILLED' },
        { value: 5, label: 'REJECTED' },
        { value: 6, label: 'EXPIRED' },
        { value: 7, label: 'REQUEST ADD' },
        { value: -1, label: 'FAILED' },

    ],
    ORDER_HISTORY_FROM_OPTION: [
        // { value: undefined, label: 'All' },
        { value: 'manual', label: 'Manual' },
        { value: 'copytrading', label: 'Copy Trading' },
        { value: 'bridge', label: 'Bridge' },
        { value: 'api', label: 'API' }

    ],
    BRIDGE_SIGNAL_OPTION: [
        { value: 'BUY', label: 'BUY' },
        { value: 'SELL', label: 'SELL' },
        { value: 'NONE', label: 'NONE' }

    ],
    EXIT_ON_OPPOSITE_OPTION: [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' }
    ],
    BRIDGE_POSITION_STATUS_OPTION: [
        { value: true, label: 'Open' },
        { value: false, label: 'Closed' }
    ],
    WALLET_COUNTRY_OPTION: [
        { value: 'UNITED STATES', label: 'UNITED STATES' },
        { value: 'RUSSIA', label: 'RUSSIA' },
        { value: 'CANADA', label: 'CANADA' },
        { value: 'INDIA', label: 'INDIA' },
        { value: 'JAPAN', label: 'JAPAN' },
        { value: 'NEW ZEALAND', label: 'NEW ZEALAND' },
        { value: 'AUSTRALIA', label: 'OTHER' },
    ],
    SL_TP_TYPE_OPTION: [
        { value: undefined, label: 'Value' },
        { value: 'PIP', label: 'Pip' },
        { value: 'PERCENTAGE', label: 'Percentage' },

    ],
    TRUE_FALSE_OPTIONS: [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' }
    ],
    STRATEFGY_SUBSCRIPTION_STATUS_OPTION: [
        { value: true, label: 'Active' },
        { value: false, label: 'Expired' },
    ]

}
export const ORDER_EXECUTION_TYPE = {
    [-1]: "DEPOSIT",
    [-2]: "WITHDRAW",
    0: 'BUY',
    1: 'SELL',
    2: 'BUY LIMIT',
    3: 'SELL LIMIT',
    4: 'BUY STOP',
    5: 'SELL STOP',
    6: 'BUY STOP LIMIT',
    7: 'SELL STOP LIMIT',
}

export const ORDER_STATE_TYPE = {
    [-1]: 'FAILED',
    [0]: 'STARTED',
    [1]: 'PLACED',
    [2]: 'CANCELED',
    [3]: 'PARTIAL',
    [4]: 'FILLED',
    [5]: 'REJECTED',
    [6]: 'EXPIRED',
    [7]: 'REQUEST ADD',
}
export const CONFIRMATION_ACTION_TYPE = {
    DELETE: 'delete',
    STATUS_UPDATE: 'status',
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    CASHOUT_CREDIT: 'cashout_credit',
    SQUARE_OFF: 'square_off',
    CANCEL: 'cancel',
    REGENERATE_KEY: 'regenerate_key',
    REFRESH: 'refresh',
    SYNC_BALANCE: 'sync_balance',
    EXTEND: 'extend',
    RENEW: 'renew',
    RESET: 'reset',
    ALLOW: 'allow',
    DISALLOW: 'disallow'
}
export const ORDER_TYPE = {
    BUY: 0,
    SELL: 1,
    BUY_LIMIT: 2,
    SELL_LIMIT: 3,
    BUY_STOP: 4,
    SELL_STOP: 5,
    BUY_STOP_LIMIT: 6,
    SELL_STOP_LIMIT: 7,
};

export const GROUP_PLACE_ORDER_FROM = {
    SINGLE_GROUPS: 'SINGLE_GROUPS',
    GROUP_INFO_CARD: 'GROUP_INFO_CARD',
    GROUP_CARD: 'GROUP_CARD'
}

export const BRIDGE_SINGLA_PLACE_OERDRE_TYPE = {
    BUY: "BUY",
    SELL: "SELL",
    EXIT: "EXIT"
}

export const RECAPTCHA_ACTIONS = {
    LOGIN: "LOGIN",
    REGISTER: "REGISTER",
    FORGOT_PASSWORD: "FORGOT_PASSWORD",
};

export const BRIDGE_TRADING_VIEW_TYPE = {
    MARKET: 'market_order',
    STRATEGY: 'strategy_order',
    LIMIT: 'limit_order',
    CANCEL: 'cancel_order',
    CLOSE: 'close_position',
    SIMULATION: 'simulation_mode'

}
export const REVERSE_BRIDGE_TRADING_VIEW_TYPE = Object.entries(BRIDGE_TRADING_VIEW_TYPE)
    .reduce((acc, [key, value]) => {
        acc[value] = key;
        return acc;
    }, {});

export const DEFAULT_STRATEGY_SYNTAX = {
    type: "strategy_order",
    symbol: "{{ticker}}",
    volume: "{{strategy.position_size}}",
    position_size: "{{strategy.position_size}}",
    side: "{{strategy.order.action}}",
    current_price: "{{close}}",
    exit_on_opposite: 0

}

export const ACCOUNT_QUEUE_STATUS = {
    CONNECTING: 'connecting',
    RENEWING: 'renewing',
    FAILED: 'failed',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
}

export const ACCOUNT_QUEUE_FROM_SCREEN = {
    ACCOUNT: 'ACCOUNT',
    CHILD_ACCOUNT: 'CHILD_ACCOUNT'
}
export const PREFERENCE = {
    COPY_TRADING: 0,
    TRADING_VIEW: 1,
    MULTI_ACC_MANAGE: 2,
    STRATEGY: 3,
}
export const CHILD_ACCOUNT_ORDER_MODES = {
    MULTIPLIER: "multiplier",
    FIXED_LOT: "fixed_lot",
    BALANCE_BASED: 'balance_based'
}
export const ACCOUNT_CONNECTION_TYPE = {
    CONNECT_WITH_SERVER: 'Connect With Server',
    CONNECT_WITH_HOST: 'Connect With Host'
}
export const DEVICE_TYPE = {
    WINDOWS: 'Android/Windows',
    MACOS: 'iOS/macOS'
}

export const CONFIGS_TAB = {
    ORGANIZATION: 'Organization',
    PAYMENT: 'Payment',
    FTP: 'FTP',
    BRANDING: 'Logo',
    THEME: 'Theme'
}

export const LOGO_TYPE = {
    HORIZONTAL_LOGO: 'horizontal_logo',
    VERTICAL_LOGO: 'vertical_logo',
}

export const STRATEGY_TYPE = {
    PRIVATE: 'private',
    PUBLIC: 'public'
}
export const GROUP_STARTEGY_DETAILS_TABS = {
    SUBSCRIPTION_PLANS: 'Subscription Plans',
    RECORDS: 'Records',
    USERS: 'Users',
    USER_SUBSCRIPTION: 'User Subscriptions'
}

export const USER_PERMISSION = {
    ACCOUNT_PERMISSION: "ACCOUNT",
    CUSTOM_BRIDGE: "CUSTOM_BRIDGE",
    JSON_BRIDGE: "JSON_BRIDGE"
}

export const USER_DETAILS_TAB = {
    ACCOUNTS: "Accounts",
    SUBSCRIBED_STRATEGY: 'Subscribed Strategy',
    ORDER_HISTORY: 'Order History',
    WALLET: 'Wallet',
    REFERRALS: 'Referrals',
    ACTIVITY_LOGS: 'Activity Logs'
}
export const ALLOW_DISALLOW_PRIVATE_STRATEGY_ACTION_TYPE = {
    ADD: 'add',
    REMOVE: 'remove'
}
export const THEME_TAB = {
    DEFAULT: 'Default Theme',
    CUSTOM: 'Custom Theme'
}
export const THEME_VARAIBLE_MAP = {
    primary_color: "--color-primary",
    background_color: "--color-background",
    hover_color: "--color-hover",
    card_color: "--color-surface-card",
    input_color: "--color-surface-input",
    subcard_color: "--color-surface-subcard",
    expiry_card_color: "--surface-expired",
    loading_overlay: "--loading-overlay",
    primary_text_color: "--color-text-primary",
    secondary_text_color: "--text-secondary",
    placeholder_text_color: "--text-placeholder",
    button_text_color: "--btn-text",
    text_color_on_primary: "--text-on-primary",
    border_color: "--color-border",
    scrollbar_color: "--color-scrollbar",
    shadow_card_color: "--shadow-card",
    error_color: "--error",
    error_bg_color: "--error-bg",
    warning_color: "--warning",
    warning_bg_color: "--warning-bg",
    info_color: "--info",
    info_bg_color: "--info-bg",
    success_color: "--success",
    success_bg_color: "--success-bg",
    pnl_profit_chart_top: "--pnl-profit-chart-top",
    pnl_profit_chart_bottom: "--pnl-profit-chart-bottom",
    pnl_loss_chart_top: "--pnl-loss-chart-top",
    pnl_loss_chart_bottom: "--pnl-loss-chart-bottom"
};

export const COUNTRY_INDIA = 'INDIA'